import { Injectable, Inject, Injector } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs/ReplaySubject';

import { AuthService } from '../auth/auth.service';
import { AppConfigurationService } from '../common/app-configuration.service';
import { DataQueryService } from '../common/data-query.service';
import { DeviceReferenceService } from '../common/device-reference.service';
import { EventsManagerService } from '../common/events-manager.service';
import { HttpInterceptor } from '../common/http-interceptor.service';
import { ModelsBuilderService } from '../common/models-builder.service';
import { MicroAppModel } from '../models/microapp.model';
import { ISmartenitConfig } from '../smartenit-config.interface';
import { DatabaseService } from '../storage/database.service';
import { PersistentCRUDService } from '../storage/persistent-crud.service';
import { SyncService } from '../storage/sync.service';

@Injectable()
export class MicroAppsService extends PersistentCRUDService {
  private isLoaded: boolean = false;
  private loadedMicroApps: ReplaySubject<any> = new ReplaySubject<any>();
  private microApps: any[] = [];

  constructor(
    http: HttpInterceptor,
    authService: AuthService,
    dbService: DatabaseService,
    syncService: SyncService,
    dataQueryService: DataQueryService,
    eventsService: EventsManagerService,
    AppConfiguration: AppConfigurationService,
    injector: Injector,
    private deviceReferenceService: DeviceReferenceService,
    private modelsBuilderService: ModelsBuilderService
  ) {
    super(
      'microapps',
      http,
      authService,
      dbService,
      syncService,
      dataQueryService,
      eventsService,
      AppConfiguration,
      injector
    );
    this.init();
  }

  public createModel(data: any): MicroAppModel {
    return new MicroAppModel(this, data);
  }

  private init() {
    if (this.deviceReferenceService.isLoaded) {
      this.loadDefinitions();
    } else {
      this.deviceReferenceService.onLoaded.subscribe((isLoaded) => {
        this.loadDefinitions();
      });
    }
  }

  private loadDefinitions() {
    if (!this.isLoaded) {
      if (
        this.deviceReferenceService.data &&
        this.deviceReferenceService.data.microapps
      ) {
        this.microApps = this.deviceReferenceService.data.microapps;
      }

      this.modelsBuilderService
        .buildModels(
          this.microApps
            .map((m) => {
              let structures: any[] = m.actions;

              if (m.slots && m.slots.length > 0) {
                structures = structures.concat(
                  ...m.slots.map((s: any) => s.devices)
                );
              }

              return structures;
            })
            .reduce((p1, p2) => p1.concat(p2), [])
        )
        .subscribe(
          () => {
            this.isLoaded = true;
            this.microApps.forEach((m) => this.loadedMicroApps.next(m));
          },
          (error) => {
            this.isLoaded = true;
            this.microApps.forEach((m) => this.loadedMicroApps.next(m));
          }
        );
    }
  }

  public getDefinition(name: string): Observable<any> {
    return this.loadedMicroApps.filter((m) => m.name === name);
  }
}
